<template>
  <div>
	<div class="zzjgBox">
		<img :src="zzjgImg" />
	</div>
  </div>
</template>

<script>
  export default {
    components: {
	
    },
	props:{
		zzjgImg:{
			typeof:String,
			default:''
		}
	},
    data() {
      return {

      }
    },
    mounted() {

    },
    methods: {

    }
  }
</script>

<style>

</style>
<style scoped lang="scss">
.zzjgBox{
	width: 1200px;
	img{
		object-fit: contain;
		width: 1200px;
		height: 793px;
	}
}
@media screen and (max-width:1200px) {
	.zzjgBox{
		width: 100% !important;
		img{
			object-fit: contain;
			width: 100% !important;
			height: auto !important;
		}
	}
}
</style>
